























































import { Component, Vue } from "vue-property-decorator";
import * as echarts from "echarts";
import axios from "axios";

@Component
export default class CdHome extends Vue {
  public bar: any;
  public baseData = {
    carNum: "",
    currentBalance: "",
    todayConsumAmount: "",
    totalRechargeAmount: ""
  };
  created() {
    //   可以用作初始化数据
    // console.log("111", document.getElementById("barBox"));
  }
  mounted() {
    this.getbasedata();
    //   元素加载完成
    let self = this;
    this.bar = echarts.init(document.getElementById(
      "barBox"
    ) as HTMLDivElement);
    this.bar.setOption({
      title: { text: "充电额报表" },
      tooltip: {
        formatter: "{a}<br/>{b}日:{c}"
      },
      xAxis: {
        data: [],
        axisLine: {
          lineStyle: {
            color: "#99abb4",
            width: 1 //这里是为了突出显示加上的
          }
        }
      },
      yAxis: {
        axisLine: {
          lineStyle: {
            color: "#000000",
            width: 1 //这里是为了突出显示加上的
          }
        }
      },
      color: "#409EFF",
      series: {
        name: "销量",
        type: "bar",
        data: []
      }
    });
    this.getchargereport();
    window.onresize = function() {
      self.bar.resize();
    };
  }
  //   getbasedata
  getbasedata() {
    axios.post("basedata", {}).then(res => {
      if (res.data.errCode == 40000) {
      } else {
        // console.log(res.data);
        this.baseData = res.data.result;
      }
    });
  }
  // getchargereport
  getchargereport() {
    axios.post("chargereport", {}).then(res => {
      if (res.data.errCode == 40000) {
        // console.log("nothing");
      } else {
        this.bar.setOption({
          xAxis: {
            data: res.data.result.x
          },
          series: {
            data: res.data.result.y
          }
        });
        // this.baseData = res.data.result;
      }
    });
  }
}
